import { render, staticRenderFns } from "./AccettazioneSsnImpegnativaComponent.vue?vue&type=template&id=e60f86c4"
import script from "./AccettazioneSsnImpegnativaComponent.vue?vue&type=script&lang=js"
export * from "./AccettazioneSsnImpegnativaComponent.vue?vue&type=script&lang=js"
import style0 from "./AccettazioneSsnImpegnativaComponent.vue?vue&type=style&index=0&id=e60f86c4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports